var jade = require("/Users/nmd/dev/vsct.info/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<h1>Контейнеры</h1><component is=\"search-form\" data-pattern=\"[^A-Za-z{4}0-9]\" data-placeholder=\"Номер контейнера…\" data-searchform=\"true\"></component><component is=\"cnt-list\"></component><component is=\"modal-dialog\" data-show=\"{{@ modal.show }}\" data-name=\"{{@ name }}\" data-components=\"{{ modal.components }}\"></component>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/components/cnt-list/template.jade
 ** module id = 137
 ** module chunks = 0
 **/